import {
  GET_OT_HOP_INITIALIZATION,
  GET_OT_HOP_INITIALIZATION_SUCCESS,
  GET_OT_HOP_INITIALIZATION_FAILURE,
} from '../actions/otHOPInitialization';

const INITIAL_STATE = { loading: true };

export default function otHOPInitializationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_OT_HOP_INITIALIZATION:
      return {
        ...state,
        loading: true,
      };
    case GET_OT_HOP_INITIALIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        hop: action.payload,
      };
    case GET_OT_HOP_INITIALIZATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
